import Header from './containers/Header';

export default Header;



// WEBPACK FOOTER //
// ./src/scenes/Header/index.ts